module.exports = __webpack_public_path__ + "img/body-type.44b64fca.svg";